/** The org-level branding field set — one shape for every scope. */
export interface BrandingValues {
  show_organization_logo: boolean;
  /**
   * left | center | right. NOT the per-item vocabulary ('header_left',
   * 'footer_center', …) used inside a single outreach's Design step — the
   * outreach wizard maps between the two.
   */
  logo_position: 'left' | 'center' | 'right';
  primary_color: string;
  secondary_color: string;
  background_color: string;
  text_color: string;
  heading_font: string;
  body_font: string;
  /** Null for the report scope, which has no layout templates to apply. */
  layout_template: 'modern' | 'corporate' | 'minimal' | 'branded' | null;
  custom_header_html: string | null;
  custom_footer_html: string | null;
}

/** Storage scopes. 'shared' is the org's brand; the others are overrides. */
export type BrandingScope = 'shared' | 'outreach' | 'report';

/** The two surfaces a brand can reach. */
export type BrandingSurface = 'outreach' | 'report';

export interface BrandingSummary {
  stored: Record<BrandingScope, (BrandingValues & { use_shared: boolean }) | null>;
  effective: Record<BrandingSurface, BrandingValues>;
  /** True when either surface currently overrides the shared brand. */
  per_surface: boolean;
}

export const BRANDING_DEFAULTS: BrandingValues = {
  show_organization_logo: true,
  logo_position: 'center',
  primary_color: '#2563eb',
  secondary_color: '#64748b',
  background_color: '#ffffff',
  text_color: '#1e293b',
  heading_font: 'Inter',
  body_font: 'Inter',
  layout_template: 'modern',
  custom_header_html: null,
  custom_footer_html: null,
};
